import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/geobooster'

Styxie.Initializers.MobileServiceTitanJobs = {
  index: async(props) => {
    const { default: JobsIndex } = await import('@/vue_widgets/geobooster/service_titan/jobs/index.vue')
    createVueApp(JobsIndex, { props, sidebar })
  },
  show: async(props) => {
    const { default: JobShow } = await import('@/vue_widgets/geobooster/service_titan/jobs/show/index.vue')
    createVueApp(JobShow, { props, sidebar })
  }
}
